import axios from "axios";
import { toast } from "react-toastify";

/**
 * Descarga un PDF de un reporte individual por ID de cronograma.
 * @param {string} id - ID del cronograma
 */
export const descargarReporteIndividual = async (id) => {
  try {
    const token = localStorage.getItem("token");
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/reportes/individual/${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob",
      }
    );

    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `servicio_${id}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (err) {
    console.error("Error al descargar PDF individual:", err);
    toast.error("No se pudo descargar el PDF");
  }
};

/**
 * Abre el PDF de un reporte individual en una pestaña nueva para vista previa
 * (sin forzar descarga). El usuario puede descargar/imprimir desde el visor
 * nativo del navegador.
 * @param {string} id - ID del cronograma
 */
export const verReporteIndividual = async (id) => {
  const win = window.open("", "_blank");
  if (!win) {
    toast.error("Habilita las ventanas emergentes para ver el acta");
    return;
  }
  try {
    const token = localStorage.getItem("token");
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/reportes/individual/${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob",
      }
    );
    const url = window.URL.createObjectURL(
      new Blob([res.data], { type: "application/pdf" })
    );
    win.location.href = url;
  } catch (err) {
    console.error("Error al abrir vista previa del PDF individual:", err);
    win.close();
    toast.error("No se pudo cargar el acta");
  }
};

/**
 * Descarga un PDF de reportes grupales por filtros de cliente y área.
 * @param {string} clienteId
 * @param {string} areaId
 */
export const descargarReporteGrupal = async (clienteId, areaId) => {
  try {
    const token = localStorage.getItem("token");
    const params = new URLSearchParams();
    if (clienteId) params.append("clienteId", clienteId);
    if (areaId) params.append("areaId", areaId);

    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/reportes/grupal?${params.toString()}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob",
      }
    );

    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `servicios_grupales.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (err) {
    console.error("Error al descargar PDF grupal:", err);
    toast.error("No se pudo descargar el PDF grupal");
  }
};
